import { render, staticRenderFns } from "./indicatorManagement.vue?vue&type=template&id=0225fe6e&scoped=true&"
import script from "./indicatorManagement.vue?vue&type=script&lang=js&"
export * from "./indicatorManagement.vue?vue&type=script&lang=js&"
import style0 from "./indicatorManagement.vue?vue&type=style&index=0&id=0225fe6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0225fe6e",
  null
  
)

export default component.exports